import { appUrls as urls } from "../utils/urls/appUrls"
import app_logo from '../assets/images/notap_logo.png'


export const pagesText = {
	// table data

	//pages title

	on_open_account_one: 'account opening request successfully submitted',
	agency_banking_request: 'Agency Banking Requests',
	reports: 'Reports',
	additional_account_request: 'Additional Account Requests',
	internet_banking_requests: 'Online Banking Activation',
	account_opening_requests: 'Account Opening Requests',
	tokenized_transactions: 'Tokenized Deposits',
	customers: 'Online Banking Customers',
	admin_user: 'System Users Management',
	admin_roles_permission: 'User Role Management',
	tier_management: 'Tier Management',
	role_management: 'Role Management',
	admin_user_add: 'Add System User',
	admin_tier_add: 'Add New Tier',
	admin_tier_update: 'Update Tier',
	admin_role_update: 'Update Roles',
	admin_role_add: 'Add New Role',

	system_logs: 'Audit Trail',
	admin_export_text: 'PRINT',
	customer_export_text: 'EXPORT',

	user_roles: [
		{
			val: 2,
			name: 'Initiator',
			key: 'initiator',
			roles: ['admin'],
		},
		{
			val: 3,
			name: 'Approver',
			key: 'approver',
			roles: ['admin'],
		},
		{
			val: 4,
			name: 'Admin',
			key: 'admin',
			roles: ['super admin'],
		},
		{
			val: 5,
			name: 'Super Admin',
			key: 'super_admin',
			roles: ['super admin'],
		},
	],
	short_date: 'YYYY-MM-DD',
	full_date: 'YYYY-MM-DD, HH:mm:ss',
	full_date_for_download: 'YYYY-MM-DD_HH:mm:ss',
}

export const englishString = {
	datatable_class: 'table table-striped',
	user_unique_id: 'notap_user',
	naira: '₦',
	appName: 'National Bank',
	app_logo: `${app_logo}`,
	app_logo_light: '/_assets/logo_header_white.svg',
	filter_btn_text: 'Apply',
	//
	first_name_label: 'First Name',
	last_name_label: 'Last Name',
	full_name: 'Full Name',
	email_label: 'Email',
	phone_number_label: 'Phone Number',
	address_label: 'Address',
	action_text_label: 'Action',
	//
	qApp_charge: 'QApp charge',
	transactions_text: 'Transactions',
	total_charges: 'Total Charges',
	value_text: 'Value',
	total_no_of_requests_text: 'Total Number of Requests',
	customer_distribution_by_tiers: 'Customer Distribution by Tier',
	daily_Position_text: 'Daily Position',
	total_transaction_value: 'Total Transaction Value (NGN)',
	total_transaction_others: 'Total Transaction Charges (Others)',
	total_number_of_transactions: 'Total Number of Transactions',
	total_qApp_charge: 'Total QApp charge (NGN)',

	//
	timeout_message: 'Your session has expired, kindly login again',
	login_success_message: 'login successful, redirect to dashboard',
	forgot_password_success_message: 'password reset email sent',
	change_security_question_success_message:
		'security question changed successfully',
	change_pin_success_message: 'pin change successful',
	update_admin_status: 'user status changed successfully',
	admin_added_successfully: 'admin added successfully',
	tier_added_successfully: 'Tier added successfully',
	role_added_successfully: 'Role added successfully',
	new_account_request_s: 'New Account Request Submitted Successfully',
	req_additional_account_approval: 'Approval request submitted successfully',
	approve_additional_account: 'Additional account approved successfully',

	logo: '../../assets/images/logo_one.svg',
	name_label: 'Name',

	identification_label: 'Identification',
	change_label: 'Edit Profile',
	personal_info_label: 'Personal Information',
	account_settings_label: '',
	others_label: 'Others',
	change_password_label: 'Change Password',
	change_transaction_pin: 'Change Transaction pin',
	security_label: 'Set Up / Change Security Question',
	sms_notification_label: 'Sms Notification Settings',
	email_notification_label: 'Email Notification Settings',
	privacy_policy_label: 'Privacy Policy',
	terms_and_condition_label:
		'By continuing you agree to the Terms and Conditions',
	terms_and_condition_text: 'Terms and Conditions',
	faq_label: 'FAQs',
	contact_us_label: 'Contact Us',
	current_pin_label: 'Current Pin',
	new_pin_label: 'New PIN',
	confirm_new_pin_label: 'Confirm New PIN',
	forgot_transaction_pin_label: 'Forgot transaction PIN?',
	reset_now_label: 'Reset Now',
	update_label: 'Update',
	change_security_questions: 'Change Security Question',
	loan_success_msg:
		'A loan of N1,500,000.00 has be granted to your \n' +
		'account and will be deducted automatically at the end\n' +
		'of each installment month.',
	loan_lead_text:
		'Please provide the following information to continue with the process',
	loan_monthly_repayment_label: 'Monthly Repayment',
	loan_total_repayment_label: 'Total Repayment',
	loan_max_tenor_label: 'Maximum Tenor (Months)',
	loan_amount_label: 'Amount',
	loan_select_loan_type_label: 'Select Loan',
	loan_interest_rate: 'Interest Rate',
	continue_text: 'Continue',
	loan_confirmation_lead_text: 'You are about to procure a loan',
	loan_next_repayment_date: 'Next Payment Date',
	enter_your_transfer_pin: 'Enter your transfer pin below',
	card_empty_state: 'No cards yet at this time',
	recent_transaction_label: 'Recent Transaction',
	view_all_label: 'View All',
	terms_and_condition: 'By continuing you agree to the Terms and Conditions'
}

export const verification_status_options = [
	{id: 1, value: 'all', text: 'All'},
	{id: 2, value: 'pending', text: 'Pending'},
	{id: 3, value: 'approved', text: 'Approved'},
	{id: 4, value: 'rejected', text: 'Rejected'},
	// {id: 5, value: 'pending_request', text: 'Pending Request'},
]

export const notap_user_roles = ['dg', 'director', 'deputydirector', 'officers'];
//#E88749

export const image_extensions = ['png', 'jpg', 'jpeg']

export const document_list = [
	// {
	// 	id: 1,
	// 	name: 'Certificate',
	// 	isRequired: true,
	// 	reference: 'certificate_file'
	// }, 
	// {
	// 	id: 2,
	// 	name:'Stamped Agreement',
	// 	isRequired: true,
	// 	reference: 'stamped_agreement_file'
	// }, 
	// {
	// 	id: 3,
	// 	name:'Cover Letter',
	// 	isRequired: true,
	// 	reference: 'cover_letter_file'
	// }, 
	{
		id: 4,
		name:'Invoice',
		isRequired: false,
		reference: 'invoice_file'
	}, 
	{
		id: 5,
		name:'Additional Document1',
		isRequired: false,
		reference: 'additional_document1_file'
	},
	{
		id: 6,
		name:'Additional Document2',
		isRequired: false,
		reference: 'additional_document2_file'
	}
]
